import React from 'react'

const Jva_cleb = () => {
    return (
        <div class='container'>
            <div class="post-content">
      <h1 class="post-title">Java program to solve Celebrity Problem using stack</h1>
     
     
      <p></p>
      <p>Hello Everyone! In this Java tutorial, we are going to discuss the problem of a celebrity program using a
            stack. We are going to use the stack method to solve this problem in Java.</p>
      <h2>How to solve the Celebrity problem in Java?</h2>
      <p>First, understand what is climb stair problem. In this problem, A superstar is someone who doesn’t recognize
            everybody but everyone recognizes him. In another word, We need to locate find the celebrity among a group
            of people on the basis of his/her popularity. A celebrity is a person who’s widely known to all people the
            various group. A superstar is someone who doesn’t recognize everybody (along with themselves) however is
            understood by means of each person. The hassle is to locate who the movie star is via asking humans
            questions of the form, “Do you know x?”. There are some conditions/regulations with the aid of which we are
            capable of discover the celebrity. The conditions/rules which follows:-. The conditions/rules which
            follows:-</p>
      <ul>
            <li>You are given a number n, representing the number of people in Array.</li>
            <li>Everyone in the group must know the celebrity.</li>
            <li>Celebrity does not know anyone in the group.</li>
            <li>The celebrity does not know himself/herself.</li>
            <li>The maximum variety of celebrities a number of the institution is one.</li>
            <li>A celebrity is characterized as someone who knows no other individual than himself except for every
                  other person knows him.</li>
      </ul>
      <h3>Java code for solving the celebrity problem</h3>
      <div
            class=" ">
           
            <div class="containers" >
                  <div class="">
                        <div><span class="library">import</span><span class="keywords">
                                    java.util.Scanner</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span><span class="library">import</span><span
                                    class="keywords"> java.util.Stack</span><span class="keywords">;</span>
                        </div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span><span class="library">public</span><span
                                    class="keywords"> </span><span class="library">class</span><span
                                    class="keywords"> Elements</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="library">private</span><span
                                    class="keywords"> </span><span class="library">static</span><span
                                    class="keywords"> </span><span class="library">final</span><span
                                    class="keywords"> Scanner sc = </span><span
                                    class="enlighter-k3">new</span><span class="keywords"> </span><span
                                    class="enlighter-m0">Scanner</span><span class="plain">(</span><span
                                    class="keywords">System.</span><span class="enlighter-m3">in</span><span
                                    class="plain">)</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="library">public</span><span
                                    class="keywords"> </span><span class="library">static</span><span
                                    class="keywords"> </span><span class="enlighter-k5">void</span><span
                                    class="keywords"> </span><span class="enlighter-m0">main</span><span
                                    class="plain">(</span><span class="enlighter-k5">String</span><span
                                    class="plain">[]</span><span class="keywords"> args</span><span
                                    class="plain">)</span><span class="keywords"> </span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-c0"> //int[][]
                                    arr=&#123;0,0,0,0&#125;,&#123;1,0,1,1&#125;,&#123;1,1,0,1&#125;,&#123;1,1,1,0&#125;;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> System.</span><span class="enlighter-m3">out</span><span
                                    class="keywords">.</span><span class="enlighter-m3">println</span><span
                                    class="plain">(</span><span class="enlighter-s0">"Enter the size of the
                                    Array:- "</span><span class="plain">)</span><span
                                    class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k5">int</span><span
                                    class="keywords"> n = sc.</span><span class="enlighter-m3">nextInt</span><span
                                    class="plain">()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k5">int</span><span
                                    class="plain">[][]</span><span class="keywords"> arr = </span><span
                                    class="enlighter-k3">new</span><span class="keywords"> </span><span
                                    class="enlighter-k5">int</span><span class="plain">[</span><span
                                    class="keywords">n</span><span class="plain">][</span><span
                                    class="keywords">n</span><span class="plain">]</span><span
                                    class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">for</span><span
                                    class="keywords"> </span><span class="plain">(</span><span
                                    class="enlighter-k5">int</span><span class="keywords"> j = </span><span
                                    class="enlighter-n1">0</span><span class="keywords">; j </span><span
                                    class="plain">&lt;</span><span class="keywords"> n; j++</span><span
                                    class="plain">)</span><span class="keywords"> </span><span
                                    class="plain">&#123;</span><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">for</span><span
                                    class="keywords"> </span><span class="plain">(</span><span
                                    class="enlighter-k5">int</span><span class="keywords"> k = </span><span
                                    class="enlighter-n1">0</span><span class="keywords">; k </span><span
                                    class="plain">&lt;</span><span class="keywords"> n; k++</span><span
                                    class="plain">)</span><span class="keywords"> </span><span
                                    class="plain">&#123;</span><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> arr</span><span class="plain">[</span><span
                                    class="keywords">j</span><span class="plain">][</span><span
                                    class="keywords">k</span><span class="plain">]</span><span
                                    class="keywords"> = sc.</span><span class="enlighter-m3">nextInt</span><span
                                    class="plain">()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> sc.</span><span class="enlighter-m3">close</span><span
                                    class="plain">()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> Stack</span><span class="plain">&lt;</span><span
                                    class="enlighter-k5">Integer</span><span class="plain">&gt;</span><span
                                    class="keywords"> obj = </span><span class="enlighter-k3">new</span><span
                                    class="keywords"> Stack</span><span
                                    class="plain">&lt;&gt;()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">for</span><span
                                    class="plain">(</span><span class="enlighter-k5">int</span><span
                                    class="keywords"> i =</span><span class="enlighter-n1">0</span><span
                                    class="keywords">;i</span><span class="plain">&lt;</span><span
                                    class="keywords">arr.</span><span class="enlighter-m3">length</span><span
                                    class="keywords">;i++</span><span class="plain">)</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> obj.</span><span class="enlighter-m3">push</span><span
                                    class="plain">(</span><span class="keywords">i</span><span
                                    class="plain">)</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">while</span><span
                                    class="plain">(</span><span class="keywords">obj.</span><span
                                    class="enlighter-m3">size</span><span class="plain">()&gt;</span><span
                                    class="keywords">=</span><span class="enlighter-n1">2</span><span
                                    class="plain">)</span><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k5">int</span><span
                                    class="keywords"> i=obj.</span><span class="enlighter-m3">pop</span><span
                                    class="plain">()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k5">int</span><span
                                    class="keywords"> j=obj.</span><span class="enlighter-m3">pop</span><span
                                    class="plain">()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">if</span><span
                                    class="plain">(</span><span class="keywords">arr</span><span
                                    class="plain">[</span><span class="keywords">i</span><span
                                    class="plain">][</span><span class="keywords">j</span><span
                                    class="plain">]</span><span class="keywords">==</span><span
                                    class="enlighter-n1">0</span><span class="plain">)</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> obj.</span><span class="enlighter-m3">push</span><span
                                    class="plain">(</span><span class="keywords">i</span><span
                                    class="plain">)</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">else</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> obj.</span><span class="enlighter-m3">push</span><span
                                    class="plain">(</span><span class="keywords">j</span><span
                                    class="plain">)</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k5">int</span><span
                                    class="keywords"> pos=obj.</span><span class="enlighter-m3">pop</span><span
                                    class="plain">()</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">for</span><span
                                    class="plain">(</span><span class="enlighter-k5">int</span><span
                                    class="keywords"> i=</span><span class="enlighter-n1">0</span><span
                                    class="keywords">;i</span><span class="plain">&lt;</span><span
                                    class="keywords">arr.</span><span class="enlighter-m3">length</span><span
                                    class="keywords">;i++</span><span class="plain">)</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">if</span><span
                                    class="plain">(</span><span class="keywords">i!=pos</span><span
                                    class="plain">)</span><span class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="enlighter-k1">if</span><span
                                    class="plain">(</span><span class="keywords">arr</span><span
                                    class="plain">[</span><span class="keywords">i</span><span
                                    class="plain">][</span><span class="keywords">pos</span><span
                                    class="plain">]</span><span class="keywords">==</span><span
                                    class="enlighter-n1">0</span><span class="keywords">||arr</span><span
                                    class="plain">[</span><span class="keywords">pos</span><span
                                    class="plain">][</span><span class="keywords">i</span><span
                                    class="plain">]</span><span class="keywords">==</span><span
                                    class="enlighter-n1">1</span><span class="plain">)</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#123;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> System.</span><span class="enlighter-m3">out</span><span
                                    class="keywords">.</span><span class="enlighter-m3">println</span><span
                                    class="plain">(</span><span class="enlighter-s0">"None"</span><span
                                    class="plain">)</span><span class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="library">return</span><span
                                    class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> System.</span><span class="enlighter-m3">out</span><span
                                    class="keywords">.</span><span class="enlighter-m3">println</span><span
                                    class="plain">(</span><span class="enlighter-s0">"Celebrity :- "</span><span
                                    class="keywords">+pos</span><span class="plain">)</span><span
                                    class="keywords">;</span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"> </span><span class="plain">&#125;</span><span
                                    class="keywords"></span></div>
                  </div>
                  <div class="">
                        <div><span class="keywords"></span><span class="plain">&#125;</span></div>
                  </div>
            </div> <br/>
          </div>
          
      <pre class="containers" data-enlighter-language="java">import java.util.Scanner; <br/>
 import java.util.Stack; <br/>
  <br/>
 public class Elements <br/>
 &#123; <br/>
     private static final Scanner sc = new Scanner(System.in); <br/>
  <br/>
     public static void main(String[] args)  <br/>
        &#123; <br/>
          <br/>
         //int[][] arr=&#123;0,0,0,0&#125;,&#123;1,0,1,1&#125;,&#123;1,1,0,1&#125;,&#123;1,1,1,0&#125;; <br/>
        &nbsp;System.out.println("Enter the size of the Array:- "); <br/>
         int n = sc.nextInt(); <br/>
         int[][] arr = new int[n][n]; <br/>
  <br/>
         for (int j = 0; j &lt; n; j++) &#123; <br/>
             for (int k = 0; k &lt; n; k++) &#123; <br/>
                 arr[j][k] = sc.nextInt(); <br/>
             &#125; <br/>
         &#125; <br/>
         sc.close(); <br/>
  <br/>
         Stack&lt;Integer&gt; obj = new Stack&lt;&gt;(); <br/>
          <br/>
         for(int i =0;i&lt;arr.length;i++) <br/>
         &#123; <br/>
             obj.push(i); <br/>
         &#125; <br/>
          <br/>
         while(obj.size()&gt;=2) <br/>
         &#123; <br/>
             int i=obj.pop(); <br/>
             int j=obj.pop(); <br/>
              <br/>
             if(arr[i][j]==0) <br/>
             &#123; <br/>
                 obj.push(i); <br/>
             &#125; <br/>
             else <br/>
             &#123; <br/>
                 obj.push(j); <br/>
             &#125; <br/>
         &#125; <br/>
         int pos=obj.pop(); <br/>
         for(int i=0;i&lt;arr.length;i++) <br/>
         &#123; <br/>
             if(i!=pos) <br/>
             &#123; <br/>
                 if(arr[i][pos]==0||arr[pos][i]==1) <br/>
                 &#123; <br/>
                     System.out.println("None"); <br/>
                     return; <br/>
                 &#125; <br/>
             &#125; <br/>
         &#125; <br/>
         System.out.println("Celebrity :- "+pos); <br/>
     &#125; <br/>
 &#125;</pre> <br/>
      <h4>Implementation using Stack</h4> <br/>
      <ul> <br/>
            <li>If the Stack is empty(which it’s far first of all), then push the element in it.</li>
            <li>Then take the two-element from the stack &amp; put them in the array index then compare whether the
                  result is 1 &amp; 0 put in the stack according to if/else conditions.</li>
            <li>Run a loop while there are more than 1 element inside the stack.</li>
            <li>Pop-top two-element from the stack (constitute them as A and B).</li>
            <li>If A knows B, then A can’t be a superstar and push B in the stack. Else if A doesn’t recognize B, then B
                  can’t be a celeb push A in the stack.</li>
            <li>Assign the closing detail in the stack as the celebrity.</li>
            <li>Run a loop from 0 to n-1 and find the count of people who knows the superstar and the number of humans
                  whom the celeb knows.</li>
            <li>If the depend on individuals who know the superstar is n-1 and the remember of people whom the superstar
                  knows is zero then print the identity of superstar else print “None”.</li>
      </ul>
      <p>&nbsp;</p>
      <p>Now, run this program see the output.</p>
      <p>Case 1</p>
      <p>Input</p>
      <pre>Enter the size of the Array:- 5 <br/>
 0 0 1 1 1 <br/>
 1 0 1 1 1 <br/>
 1 1 0 1 1 <br/>
 0 0 0 0 0 <br/>
 1 0 1 1 0</pre>
      <p>Output</p>
      <pre>Celebrity:- 3</pre>
      <p>In this case, 4 row is our celebrity.</p>
      <p>Case 2</p>
      <p>Input</p>
      <pre>Enter the size of the Array:- 5 <br/>
 0 0 1 1 1 <br/>
 1 0 1 1 1 <br/>
 1 1 0 1 1 <br/>
 0 1 0 0 1 <br/>
 1 0 1 1 0</pre>
      <p>Output</p>
      <pre>None</pre>
      <p>In this case, no one is a celebrity.</p>
      <p>Now, You can understand how to solve the Celebrity problem.</p>
     
      <p></p>
     
      </div>
</div>
        
    )
}

export default Jva_cleb
